import { useEffect, useState } from 'react'
import ReactPlayer from 'react-player'
import { isMobile } from 'react-device-detect'
import axios from 'axios'

import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';

import './App.css'
import 'animate.css'
import 'bootstrap/dist/css/bootstrap.min.css'

import logo from './img/logo.png'
import serviceTitle from './img/servicios.png'
import clientesTitle from './img/clientes.png'
import contactoTitle from './img/contacto.png'
import media from './img/media.png'
import estrategia from './img/estrategia.png'
import serv3 from './img/serv3.png'
import serv4 from './img/serv4.png'
import serv5 from './img/serv5.png'
import serv6 from './img/serv6.png'
import serv7 from './img/serv7.png'
import serv8 from './img/serv8.png'
import serv9 from './img/serv9.png'
import serv10 from './img/serv10.png'

import adorno1 from './img/adorno1.png'
import adorno2 from './img/adorno2.png'
import adorno3 from './img/adorno3.png'
import adorno4 from './img/adorno4.png'
import adorno5 from './img/adorno5.png'
import adorno6 from './img/adorno6.png'
import adorno7 from './img/adorno7.png'
import adorno8 from './img/adorno8.png'
import adorno9 from './img/adorno9.png'
import adorno10 from './img/adorno10.png'
import adorno11 from './img/adorno11.png'
import adorno12 from './img/adorno12.png'

import elipse from './img/elipse.png'
import elipse2 from './img/elipse2.png'
import whats from './img/whats.png'
import insta from './img/insta.png'
import face from './img/face.png'
import linked from './img/in.png'
import tiktok from './img/tiktok.png'

import wagen from './img/wagen.png'
import sanpablo from './img/sanpablo.png'
import terraza from './img/terraza.png'
import cristal from './img/cristal.png'
import plasalud from './img/plasalud.png'
import dnatural from './img/dnatural.png'
import plaza from './img/plaza.png'

import cristalj from './img/cristalj.png'
import divo from './img/divo.png'
import garange from './img/garange.png'
import gasmetro from './img/gasmetro.png'
import sanpablop_w from './img/sanpablop_w.png'
import vw from './img/vw.png'

function App() {
  const [isLoading, setLoading] = useState(false)
  const [name, setName] = useState("")
  const [phone, setPhone] = useState("")
  const [email, setEmail] = useState("")
  const [comments, setComments] = useState("")

  const [showMessage, setShowMessage] = useState(false)
  const [title, setTitle] = useState('')
  const [message, setMessage] = useState('')

  const [show, setShow] = useState(false);

  useEffect(() => {
    const loadScriptByURL = (id, url, callback) => {
      const isScriptExist = document.getElementById(id);

      if (!isScriptExist) {
        var script = document.createElement("script");
        script.type = "text/javascript";
        script.src = url;
        script.id = id;
        script.onload = function () {
          if (callback) callback();
        };
        document.body.appendChild(script);
      }

      if (isScriptExist && callback) callback();
    }

    // load the script by passing the URL
    loadScriptByURL("recaptcha-key", `https://www.google.com/recaptcha/api.js?render=6LdCWnsnAAAAAPzMX6aHkNNvs4a47SN1jI6ptYbM`, function () {
      console.log("Script loaded!");
    });
  }, []);

  const handleShow = () => setShowMessage(true);
  const handleOnSubmit = (event) => {
    event.preventDefault();

    /*window.grecaptcha.ready(() => {
      window.grecaptcha.execute("6LdCWnsnAAAAAPzMX6aHkNNvs4a47SN1jI6ptYbM", { action: 'submit' }).then(token => {
        setLoading(true);
        var form = document.getElementById("contactForm");
        var formData = new FormData(form);
        formData.append('recaptcha_response', token);

        setLoading(true);
        axios.post("https://inmobiplace.com/api/contactAfirmativo/", formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
          }).then(function(response) {

            if(response.data == "FAIL" || response.data == "ERROR") {
              setLoading(false)
              setTitle("Error")
              setMessage("Ocurrió un error al intentar enviar tu mensaje, por favor intenta mas tarde.");
              handleShow()
            } else {
              setLoading(false)
              setTitle("Mensaje enviado")
              setMessage("Tu mensaje ha sido enviado. En breve nos comunicaremos contigo. Gracias.");
              handleShow()

              setName("");
              setPhone("");
              setEmail("");
              setComments("");
            }

          }).catch(function(err) {
            setLoading(false)
            setTitle("Error")
            setMessage("Ocurrió un error al intentar enviar tu mensaje, por favor intenta mas tarde.");
            handleShow()
          });
      });
    });*/
  }

  return (
    <>
      <div className="App">

        <Container style={{ position: 'relative' }}>
          <div className='adorno-01 mobile-hide'><img src={adorno1} className='adorno-01-img' /></div>
          <div>
            <img src={logo} className='logo' />
          </div>
          <div align="right">
            <ReactPlayer className="player-v" url='mole.mp4' playing={true} loop={true} volume={0} muted={true} controls={true} />
          </div>
          <div style={{ position: 'relative' }}>
            <div className='adorno-02 mobile-hide'><img src={adorno2} className='adorno-02-img' /></div>
            <div className='contact-home'> ¡Contáctanos! </div>
          </div>
        </Container>

        <Container>
          <div style={{ position: 'relative' }}>
            <div className='adorno-03 mobile-hide'><img src={adorno3} className='adorno-03-img' /></div>
            <div className='adorno-04 mobile-hide'><img src={adorno4} className='adorno-04-img' /></div>
            <div className='adorno-05 mobile-hide'><img src={adorno5} className='adorno-05-img' /></div>
            <img src={serviceTitle} className='service-title' />
          </div>
          <Container className='services-container'>
            <Row className='pb-1' style={{ position: 'relative' }}>
              <div className='adorno-07 mobile-hide'><img src={adorno7} className='adorno-07-img' /></div>
              <Col md={1} className='no-padding' />
              <Col md={5} className='no-padding service-img-div' style={{ backgroundImage: 'url(' + media + ')' }}>
                <img src={media} className='service-img' />
                <div className="centered">
                  <div className='image-title'> Social media </div>
                </div>
              </Col>
              <Col md={6} className='no-padding service-img-div' style={{ backgroundImage: 'url(' + estrategia + ')' }}>
                <img src={estrategia} className='service-img' />
                <div className="centered">
                  <div className='image-title'> Estrategia Digital </div>
                </div>
              </Col>
            </Row>
            <Row className='pb-1' style={{ position: 'relative' }}>
              <div className='adorno-09 mobile-hide'><img src={adorno9} className='adorno-09-img' /></div>
              <Col md={6} className='no-padding service-img-div' style={{ backgroundImage: 'url(' + serv3 + ')' }}>
                <img src={serv3} className='service-img' />
                <div className="centered">
                  <div className='image-title'> Creación de contenido </div>
                </div>
              </Col>
              <Col md={5} className='no-padding service-img-div' style={{ backgroundImage: 'url(' + serv4 + ')' }}>
                <img src={serv4} className='service-img' />
                <div className="centered">
                  <div className='image-title'> Fotografía y video </div>
                </div>
              </Col>
              <Col md={1} className='no-padding' />
            </Row>
            <Row className='pb-1' style={{ position: 'relative' }}>
              <div className='adorno-06 mobile-hide'><img src={adorno6} className='adorno-06-img' /></div>
              <Col md={1} className='no-padding' />
              <Col md={5} className='no-padding service-img-div' style={{ backgroundImage: 'url(' + serv5 + ')' }}>
                <img src={serv5} className='service-img' />
                <div className="centered">
                  <div className='image-title'> Realidad Aumentada </div>
                </div>
              </Col>
              <Col md={6} className='no-padding service-img-div' style={{ backgroundImage: 'url(' + serv6 + ')' }}>
                <img src={serv6} className='service-img' />
                <div className="centered">
                  <div className='image-title'> Fake out of home </div>
                </div>
              </Col>
            </Row>
            <Row className='pb-1' style={{ position: 'relative' }}>
              <div className='adorno-08 mobile-hide'><img src={adorno8} className='adorno-08-img' /></div>
              <div className='adorno-11 mobile-hide'><img src={adorno11} className='adorno-11-img' /></div>
              <Col md={6} className='no-padding service-img-div' style={{ backgroundImage: 'url(' + serv7 + ')' }}>
                <img src={serv7} className='service-img' />
                <div className="centered">
                  <div className='image-title'> Diseño Web </div>
                </div>
              </Col>
              <Col md={5} className='no-padding service-img-div' style={{ backgroundImage: 'url(' + serv8 + ')' }}>
                <img src={serv8} className='service-img' />
                <div className="centered">
                  <div className='image-title'> Influencers Marketing </div>
                </div>
              </Col>
              <Col md={1} className='no-padding' />
            </Row>
            <Row className='pb-1' style={{ position: 'relative' }}>
              <div className='adorno-10 mobile-hide'><img src={adorno10} className='adorno-10-img' /></div>
              <Col md={1} className='no-padding' />
              <Col md={5} className='no-padding service-img-div' style={{ backgroundImage: 'url(' + serv9 + ')' }}>
                <img src={serv9} className='service-img' />
                <div className="centered">
                  <div className='image-title'> Campañas digitales </div>
                </div>
              </Col>
              <Col md={6} className='no-padding service-img-div' style={{ backgroundImage: 'url(' + serv10 + ')' }}>
                <img src={serv10} className='service-img' />
                <div className="centered">
                  <div className='image-title'> Programatic </div>
                </div>
              </Col>
              <div className='adorno-12 mobile-hide'><img src={adorno7} className='adorno-12-img' /></div>
            </Row>
          </Container>
        </Container>

        <div className='space' />
        <Container>
          <div align="left"> <img src={clientesTitle} className='clientes-title' /> </div>
          <div className='clientes-container'>
            <Container>
              <Row className='align-items-center'>
                <Col md={3} xs={6}>
                  <img src={cristalj} className='clientes-img' />
                </Col>
                <Col md={3} xs={6}>
                  <img src={divo} className='clientes-img' />
                </Col>
                <Col md={3} xs={6}>
                  <img src={garange} className='clientes-img' />
                </Col>
                <Col md={3} xs={6}>
                  <img src={gasmetro} className='clientes-img' />
                </Col>
              </Row>
              <Row className='align-items-center pt-4'>
                <Col md={2} xs={0} className='mobile-hide' />
                <Col md={2} xs={6}>
                  <img src={sanpablop_w} className='clientes-img-2' />
                </Col>
                <Col md={1} xs={0} className='mobile-hide' />
                <Col md={2} xs={6}>
                  <img src={dnatural} className='clientes-img-2' />
                </Col>
                <Col md={1} xs={0} className='mobile-hide' />
                <Col md={3} xs={12}>
                  <img src={vw} className='clientes-img-2' />
                </Col>
                <Col md={1} xs={0} className='mobile-hide' />
              </Row>
            </Container>
            <div className='clientes-elipse-container mobile-hide'><img src={elipse} className='clientes-elipse' /></div>
          </div>
        </Container>
        <div className='space2' />

        <Container style={{ position: 'relative' }}>
          <div className='adorno-contacto mobile-hide'><img src={adorno12} className='adorno-contacto-img' /></div>
          <div className='contacto-elipse-container mobile-hide'><img src={elipse2} className='contacto-elipse' /></div>
          <div align="right"> <img src={contactoTitle} className='contacto-title' /> </div>
          <br />
          <div className='contacto-container'>
            <Container className='contacto-form'>
              <div align="left">
                <span className='contacto-circle' /> &nbsp;&nbsp;
                <span className='contacto-circle' /> &nbsp;&nbsp;
                <span className='contacto-circle' />
              </div>
              <div className='space3' />
              <Form id="contactForm" onSubmit={handleOnSubmit}>
                <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                  <Form.Control type="text" className='form-footer' placeholder="Nombre:" name='name' value={name} onChange={() => setName()} /><br />
                  <Form.Control type="email" className='form-footer' placeholder="Email:" name='email' value={email} onChange={() => setEmail()} /><br />
                  <Form.Control type="number" className='form-footer' placeholder="Teléfono:" name='phone' value={phone} onChange={() => setPhone()} />
                </Form.Group>
                <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                  <Form.Control as="textarea" className='form-footer' placeholder="Mensaje:" rows={3} name='comments' value={comments} onChange={() => setComments()} />
                </Form.Group>
                <Button disabled={isLoading} className="contacto-button" type="submit" >{isLoading ? 'Enviando…' : 'ENVIAR'}</Button>
              </Form>
            </Container>
          </div>
        </Container>

        <div className='space' />

        <Container>
          <a href=" https://wa.me/5215580947307" target='_blank'>
            <div align="center">
              <div> <img src={whats} className='whats-icon' /> </div>
              <div className='whats-text'> WhatsApp: <div className='mobile-linebreak web-hide' /> 55 8094 7307 </div>
            </div>
          </a>
          <br />
          <div align={"center"}>
            <a href='https://mgmarketinggroup.com.mx/' target='_blank'><div className='footer-team'> By Marketing Group </div></a>
          </div>
        </Container>

        <div className='space' />

        <div className='footer' >
          <Container>
            <Row className='align-items-center'>
              <Col md={3} xs={6}>
                <a href='https://www.instagram.com/mole.creativo/' target='_blank'>
                  <img src={insta} className='footer-icon' />
                  <div className='mobile-linebreak web-hide' />
                  <span className='footer-text'> @mole.creativo </span>
                  <div className='mobile-linebreak web-hide' />
                </a>
              </Col>
              <Col md={3} xs={6}>
                <a href='https://www.facebook.com/people/Mole-Creativo/61572209906419/' target='_blank'>
                  <img src={face} className='footer-icon' />
                  <div className='mobile-linebreak web-hide' />
                  <span className='footer-text'> MoleCreativo </span>
                  <div className='mobile-linebreak web-hide' />
                </a>
              </Col>
              <Col md={3} xs={6}>
                <a href='https://www.linkedin.com/company/106752022/admin/dashboard/' target='_blank'>
                  <img src={linked} className='footer-icon' />
                  <div className='mobile-linebreak web-hide' />
                  <span className='footer-text'> MoleCreativo </span>
                  <div className='mobile-linebreak web-hide' />
                </a>
              </Col>
              <Col md={3} xs={6}>
                <a href='https://www.tiktok.com/@mole.creativo?_t=ZS-8wZkIRL4Px9&_r=1' target='_blank'>
                  <img src={tiktok} className='footer-icon' />
                  <div className='mobile-linebreak web-hide' />
                  <span className='footer-text'> @mole.creativo</span>
                  <div className='mobile-linebreak web-hide' />
                </a>
              </Col>
            </Row>
          </Container>
        </div>

      </div>
    </>
  );
}

export default App;
